import { Skeleton, Stack } from '@mui/material';
import { FOLDERS_PER_ROW } from '../../constant/numericParams';

const FolderPreviewSkeleton = ({
  numberperEachRow = FOLDERS_PER_ROW,
}: {
  numberperEachRow?: number;
}) => {
  return (
    <div
      className={`grid-autofit-col mb-4`}
      style={{
        gridTemplateRows: 'auto',
        gridAutoRows: 0,
        overflow: 'hidden',
      }}
    >
      {Array.from(new Array(numberperEachRow)).map((item, index) => (
        <div key={index} className="mx-2 my-2 p-4">
          <Stack direction={'row'} spacing={3}>
            <Skeleton variant="rounded" width={70} height={40} />
            <div className="w-full">
              <Skeleton width="60%" />
              <Skeleton width="100%" />
            </div>
          </Stack>
        </div>
      ))}
    </div>
  );
};

export default FolderPreviewSkeleton;
